import { get, set } from 'lodash';

import {
  IModalDialogOptions,
  SchemaNode,
  IEntityConfig,
  ENTITY_TYPES,
  TRANSFER_TYPE,
  WIDGET_COMPONENT,
  TRANSFER_TYPE_ENUM_OPTIONS,
} from '@app/shared/types';
import { WIDGET_FAMILY } from '@config/global-constants';
import { BTN_CANCEL, BTN_CONTINUE } from '@app/text-content/button-templates';
import { TransferService } from './transfer.service';
import { getCreateAutoPopulateData } from '@app/shared/utils/route.utils';
import { I18n } from '@app/i18n/strings-keys';

const transferEntityType: ENTITY_TYPES = ENTITY_TYPES.TRANSFER;
const transferServiceConfig: IEntityConfig = {
  ENTITY_TYPE: transferEntityType,
  isMasterListAvailable: true,
  buttons: {},
  editor: {
    enableEntryDuplicate: true,
    beforePageLoadPopupConfig: {
      modalDialogOptionsMapper: async (
        modalDialogOptions: IModalDialogOptions,
        schema: SchemaNode,
        editor,
      ): Promise<IModalDialogOptions> => {
        set(
          modalDialogOptions,
          'schema.properties.transfer_type',
          schema.properties.transfer_type,
        );

        const autoPopulateData = getCreateAutoPopulateData(editor.routeState$);

        return set(
          modalDialogOptions,
          'schema.properties.transfer_type.default',
          get(
            autoPopulateData,
            'transfer_type',
            TRANSFER_TYPE.PRE_EVENT_TRANSFER,
          ),
        );
      },
      modalDialogOptions: {
        formRules: {
          fields: {
            transfer_type: {
              title: I18n.Common.Type,
              widget: WIDGET_COMPONENT.input_radio,
              widgetFamily: WIDGET_FAMILY.XUX,
              optionText: TRANSFER_TYPE_ENUM_OPTIONS,
            },
          },
          defaultGroup: true,
        },
        buttons: [BTN_CONTINUE, BTN_CANCEL],
        title: I18n.Forms.TransferForm.ChooseTransferType,
      },
    },
  },
  needConvertTimeZoneFields: ['transaction_date'],
  apiEndpoint: transferEntityType,
  uiRoute: transferEntityType,
  isFormServiceSupported: true,
  requiredPermissions: ['transfer.View'],
  list: {
    gridOptions: {
      valueField: '_id',
    },
    documentQuery: {
      orderby: 'updated_at desc',
      notNeedActive: true,
      select: ['site_id', 'updated_items', 'unavailable_items'],
    },
    documentOperationOptions: {
      skipMappers: true,
      additionalFetch: ['validate-change'],
    },
    columns: [],
    async beforeFetchListData(entityService: TransferService): Promise<void> {
      const fetchSiteFromDataSourceList = async (): Promise<void> => {
        entityService.siteFromDataSource =
          await entityService.siteFromDataSourceFetchList();
      };

      await fetchSiteFromDataSourceList();
    },
  },
};

export { transferEntityType, transferServiceConfig };
